<template>
<w-settings-content-template>
  <div slot="content">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">관리 대상 목록</div>
        <!-- <el-button class="mr-r4" type="primary" size="mini" @click="clickAddServerButton">수동 등록</el-button> -->
        <!-- <w-group-save-button class="mr-r4" :disabled="checkedRows.length == 0" managetype-id="APM"
        :rsc-event-rule-list="rscEventRuleList" :event-alarm-rule-list="eventAlarmRuleList" @group-save="groupSave"/> -->
        <el-button class="mr-r15" size="mini" :disabled="checkedRows.length == 0" @click="onClickDeleteButton">장비 삭제</el-button>
         <span class="mr-r5">관리여부</span>
        <div class="setting-addel">
         <el-button size="mini" @click="AllCheckChangeButtonClick('1')"><i class="fas fa-check-square"></i></el-button>
          <el-button size="mini" @click="AllCheckChangeButtonClick('0')"><i class="far fa-square"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box">
        <el-checkbox v-model="lastThreeDaysFlag" @change="onChangeThreeFlag">최근 3일 이내 등록된 장비 <em>{{recentRegisteredObjCount}}개</em></el-checkbox>
        <el-button class="mr-r4" type="primary" size="mini" @click="onClickSaveButton" :disabled="!cellEditing.isModified">저장</el-button>
        <el-button class="mr-r4" size="mini" @click="loadData" :disabled="!cellEditing.isModified">취소</el-button>
        <w-header-pagination class="mr-r4" :pagination="pagination" @current-change="handlerHeaderCurrentChange"></w-header-pagination>
        <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-row>
      <el-table-wrapper v-loading="isLoading" :editable="true" :data="apmTableData" :columns="apmTableColumns" :column-default="columnDefault" ref="apmTable"
        @selection-change="changeCheckedRow" :pagination="true" :show-search-tool="showSearchTool" :show-custom-header="true"
        @condition-change="loadInstance"
        @cell-dblclick="startEdit"
        remote :total="total">
        <template slot-scope="scope" slot="switch-slot">
          <w-switch-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" active-value="1" inactive-value="0" @cell-edit-end="editTwoStatusCell" />
        </template>
        <template slot-scope="scope" slot="input-slot">
          <w-input-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" @cell-edit-end="endEdit" />
        </template>
        <template slot-scope="scope" slot="model-slot">
          <w-select-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :list="filteredObjProductList"
            keyField="objProductId" labelField="objProductId" valueField="objProductId" @cell-edit-end="endEdit" />
        </template>
        <template slot-scope="scope" slot="checkbox-slot">
          <w-checkbox-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" true-label="1" false-label="0" @cell-edit-end="editTwoStatusCell" />
        </template>
        <template slot-scope="scope" slot="rsc-rule-slot">
          <w-select-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :list="rscEventRuleList"
            keyField="ruleTmplId" labelField="ruleTmplName" valueField="ruleTmplId" @cell-edit-end="endEdit" />
        </template>
        <template slot-scope="scope" slot="event-rule-slot">
          <w-select-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :list="eventAlarmRuleList"
            keyField="ruleTmplId" labelField="ruleTmplName" valueField="ruleTmplId" @cell-edit-end="endEdit"/>
        </template>
      </el-table-wrapper>
    </el-row>
  </div>
</w-settings-content-template>
</template>

<script>
import { cloneDeep, isNil, filter, isEmpty } from 'lodash';

import { columnDefault, defaultPagination } from '@/constants/table';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';

import ApmRegistrationAPI from '@/api/settings/common/device-registration-apm';
import RuleAPI from '@/api/settings/common/rule';
import CommonAPI from '@/api/config/common';

import CellEditingMixin from '@/mixins/table/cell-editing';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WHeaderPagination from '@/components/table/HeaderPagination';
import WInputEditor from '@/components/table/cell-editor/InputEditor';
import WCheckboxEditor from '@/components/table/cell-editor/CheckboxEditor';
import WSwitchEditor from '@/components/table/cell-editor/SwitchEditor';
import WSelectEditor from '@/components/table/cell-editor/SelectEditor';
import WGroupSaveButton from '@/views/settings/basic/DeviceRegistration/components/GroupSaveButton';

export default {
  name: 'WApm',
  mixins: [CellEditingMixin],
  components: {
    WSettingsContentTemplate,
    WHeaderPagination,
    WInputEditor,
    WCheckboxEditor,
    WSwitchEditor,
    WSelectEditor,
    WGroupSaveButton,
  },
  data() {
    return {
      pagination: cloneDeep(defaultPagination),
      isLoading: false,
      columnDefault,
      total: 0,
      showSearchTool: false,
      apmTableData: [],
      checkedRows: [],
      lastThreeDaysFlag: false,
      objProductList: [],
      filteredObjProductList: [],
      rscEventRuleList: [],
      eventAlarmRuleList: [],
      recentRegisteredObjCount: 0,
      loadFromThreeDataFlag: false,
      apmTableColumns: [
        {
          // align: 'center',
          type: 'selection',
        },
        {
          prop: 'objManagementApplyFlag',
          label: '관리여부',
          editable: true,
          scopedSlot: 'switch-slot',
          width: 70,
          sortable: true,
          filters: [
            {
              text: '관리',
              value: '1',
            },
            {
              text: '비관리',
              value: '0',
            },
          ],
        },
        {
          prop: 'objName',
          label: '인스턴스명',
          editable: true,
          scopedSlot: 'input-slot',
          minwidth: 150,
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP',
          width: 120,
          sortable: true,
          searchable: true,
        },
        {
          prop: 'objtypeName',
          label: 'WAS 종류',
          width: 120,
          formatter: this.formatterForCheckEmptyValue,
          searchable: true,
        },
        {
          prop: 'objProductId',
          label: 'WAS 버전',
          editable: true,
          scopedSlot: 'model-slot',
          width: 120,
          searchable: true,
          formatter: this.formatterForCheckEmptyValue,
        },
        {
          prop: 'version',
          label: '에이전트 버전',
          formatter: this.formatterForCheckEmptyValue,
          searchable: true,
        },
        {
          prop: 'agentManagerIpaddress',
          label: '에이전트매니저 IP',
          width: 120,
          searchable: true,
        },
        {
          prop: 'eventExceptFlag',
          label: '이벤트 제외',
          editable: true,
          scopedSlot: 'checkbox-slot',
          width: 80,
          align: 'center',
        },
        {
          prop: 'rscEventRuleId',
          label: '수집/판단정책',
          editable: true,
          scopedSlot: 'rsc-rule-slot',
          width: 190,
          searchable: true,
          remoteProp: 'rscrt.rule_tmpl_name',
        },
        {
          prop: 'eventAlarmRuleId',
          label: '이벤트/판단정책',
          editable: true,
          scopedSlot: 'event-rule-slot',
          width: 190,
          searchable: true,
          remoteProp: 'eventrt.rule_tmpl_name',
        },
        {
          prop: 'registDatetime',
          label: '장비 등록일',
          width: 130,
          formatter: this.getDateFormatter,
          searchable: true,
          sortable: true,
          searchType: 'date',
        },
      ],
    };
  },
  created() {
    CommonAPI.getObjProductList({}).then((res) => {
      this.objProductList = res.data.data;
    });
    RuleAPI.getRscEventRules().then((response) => {
      this.rscEventRuleList = response.data.data;
    });
    RuleAPI.getEventAlarmRulesByManagetypeId('APM2X').then((response) => {
      this.eventAlarmRuleList = response.data.data;
    });
  },
  mounted() {
    this.loadData();
  },
  methods: {
    /**
     * 인스턴스 및 최근 3일 이내 등록된 장비 개수를 조회한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      // 최근 3일 이내 등록된 장비 개수 조회
      ApmRegistrationAPI.getRecentRegisteredInstanceCount().then((response) => {
        if (response.data.success) {
          this.recentRegisteredObjCount = response.data.data;
        } else {
          this.recentRegisteredObjCount = 0;
        }
      });

      this.loadInstance();
    },
    /**
     * 인스턴스를 조회한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadInstance() {
      const tableParams = this.$refs.apmTable.getParameter();
      const params = {
        lastThreeDaysFlag: this.lastThreeDaysFlag,
        ...tableParams,
      };
      // '최근 3일 이내 등록된 장비' 클릭 시 start 값이 기존 값으로 남아있는 문제 인지, 초기화 추가
      if (this.loadFromThreeDataFlag) {
        params.start = 0;
      }
      this.isLoading = true;
      this.loadFromThreeDataFlag = false;
      ApmRegistrationAPI.getInstanceList(params).then((response) => {
        this.total = response.data.total;
        const data = cloneDeep(response.data.data);
        this.apmTableData = this.getEditableTableData(data, this.apmTableColumns);
        this.resetCellEditing();
      }).finally(() => {
        this.isLoading = false;
      });
    },
    /**
     * [테이블 페이징] 페이지 변경 핸들러
     * @author Ju
     * @param  {Object} pagination 페이지 정보 객체
     */
    handlerPaginationChange(_pagination) {
      this.pagination = _pagination;
    },
    /**
     * [헤더 페이징] 현재 페이지 변경 핸들러
     * @author Ju
     * @param  {Number} currentPage 현재 페이지 번호
     */
    handlerHeaderCurrentChange(_currentPage) {
      this.$refs.apmTable.setCurrentPage(_currentPage);
    },
    /**
     * 빈문자열 체크
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    formatterForCheckEmptyValue(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 인스턴스의 정보를 수정한다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickSaveButton() {
      const updatedData = this.getUpdatedDatas(this.apmTableData, true, ['objId', 'ipaddress', 'objCompanyId']);
      ApmRegistrationAPI.updateInstanceInfo(updatedData).then((response) => {
        if (response.data.success) {
          this.loadData();
        }
        this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '인스턴스', response.data.success));
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '인스턴스', false));
      });
    },
    /**
     * 삭제할 인스턴스 정보 저장
     * @param  {[type]} selection [description]
     * @return {[type]}           [description]
     * @author jda
     */
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
    /**
     * 인스턴스를 삭제한다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickDeleteButton() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        ApmRegistrationAPI.deleteInstances(this.checkedRows).then((response) => {
          if (response.data.success) {
            this.loadData();
          }
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '인스턴스', response.data.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '인스턴스', false));
        });
      }).catch(() => {});
    },
    /**
     * 장비 등록일 formatter
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    /**
     * 관리여부 전체 선택 및 해제
     * @param  {[type]} objManagementApplyFlag [description]
     * @author jda
     */
    AllCheckChangeButtonClick(objManagementApplyFlag) {
      const result = this.editDirectBulk(this.apmTableData, 'objManagementApplyFlag', objManagementApplyFlag);
      this.apmTableData = result.tableData;
      this.completeEditBulk(...result);
    },
    /**
     * objProductId일 경우 objtypeId에 해당하는 버전 목록만 설정.
     * @param  {[type]} data     [description]
     * @param  {[type]} property [description]
     * @return {[type]}          [description]
     * @author jda
     */
    handlerStartEdit(data, property) {
      if (property === 'objProductId') {
        if (!isEmpty(data.objtypeId)) {
          this.filteredObjProductList = filter(this.objProductList, (item) => item.objtypeId === data.objtypeId);
        } else {
          this.filteredObjProductList = [];
        }
      }
    },
    handlerEndEdit() {
      this.checkExistModifiedData(this.apmTableData);
    },
    onChangeThreeFlag() {
      this.loadFromThreeDataFlag = true;
      this.$nextTick(() => {
        this.$refs.apmTable.setCurrentPage(1);
      });
    },
    groupSave(data) {
      if (!isEmpty(data)) {
        const checkedRows = cloneDeep(this.checkedRows);
        const updatedData = checkedRows.map((item) => Object.assign({}, item, data));
        ApmRegistrationAPI.updateInstanceInfo(updatedData).then((response) => {
          if (response.data.success) {
            this.loadData();
          }
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '인스턴스', response.data.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '인스턴스', false));
        });
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Apm/index.vue